export const socialMediaLinks = [
    {
        icons: "fa-linkedin",
        url: "https://www.linkedin.com/in/parthgabani/",
    },
    {
        icons: "fa-github",
        url: "https://github.com/parthgabani777/",
    },
    {
        iconURL:
            "https://res.cloudinary.com/delp8ph1h/image/upload/v1662909907/portfolio/hashnode.png",
        url: "https://parthgabani.hashnode.dev/",
    },
];
